import styled from "styled-components";

export const Title = styled.h6`
  padding-bottom: 10px;
`;
